import axios, { CreateAxiosDefaults, AxiosInstance } from 'axios';
import { serviceDefaultConfig } from '@/config/service';

export default function Axios(config?: CreateAxiosDefaults) {
    config = { ...serviceDefaultConfig, ...config };
    const service = axios.create(config);
    setupFormatParams(service);
    return service;
}

function setupFormatParams(service: AxiosInstance) {
    service.interceptors.request.use(
        (config) => {
            const method = (config.method || 'get').toLocaleLowerCase();
            // 将请求统一变成 data
            ['post', 'put'].includes(method) && (config.data = config.data);
            ['get', 'delete'].includes(method) && (config.params = config.data);
            return config
        },
        (error) => {
            console.error(error)
            return Promise.reject(error)
        }            
    )
}